// Update this list whenever you add new files to public/assets/images/
export const AVAILABLE_IMAGES = [
    {
        name: "simplified logo",
        filename: "logo.png", // Assumes file is in public/assets/images/
    },
    {
        name: "Kai picture",
        filename: "Kai.jpg",
    },
    {
        name: "Jakery",
        filename: "Jakery.png",
    },
    {
        name: "NYCBridge_Bio",
        filename: "NYC.Bridge Bio.png",
    },
    {
        name: "BridginWithKaiPicture",
        filename: "Bridgin_With_Kai.png",
    },
    {
        name: "jaz",
        filename: "Jaz.png",
    },
    {
        name: "Beans",
        filename: "Beans.png",
    },
    {
        name: "Stell",
        filename: "John_Stell.png",
    },
    {
        name: "Jordan",
        filename: "Jordan.png",
    },
    {
        name: "Jynxie",
        filename: "Jynxie.png",
    },
    {
        name: "Kai",
        filename: "Kai.png",
    },
    {
        name: "Kuchung",
        filename: "Kuchung.png",
    },
    {
        name: "Maya",
        filename: "Maya.png",
    },
    {
        name: "Morgan",
        filename: "Morgan.png",
    },
    {
        name: "Music",
        filename: "Music.png",
    },
    {
        name: "Paulo",
        filename: "Paulo.png",
    },
    {
        name: "Pete",
        filename: "Pete.png",
    },
    {
        name: "Proquar",
        filename: "Proquar_.png",
    },
    {
        name: "Quan",
        filename: "Quan.png",
    },
    {
        name: "Rasern",
        filename: "Rasern.png",
    },
    {
        name: "RGoss",
        filename: "RGoss.png",
    },
    {
        name: "SBU_Juniors",
        filename: "SBU_JUNIROS.png",
    },
    {
        name: "Steve",
        filename: "Steve.png",
    },
    {
        name: "Bridge with Music BIO",
        filename: "bridge_with_music BIO.png",
    },
    {
        name: "Bridge with Steve BIO",
        filename: "Bridge_with_Steve BIO.png",
    },
    {
        name: "BridgeBabe530big BIO",
        filename: "BridgeBabe530big BIO.png",
    },
    {
        name: "BridgeOverlord201 BIO",
        filename: "BridgeOverlord201 BIO.png",
    },
    {
        name: "Bridgin With Kai",
        filename: "Bridgin With Kai.png",
    },
    {
        name: "Equantion_3 BIO",
        filename: "Equantion_3 BIO.png",
    },
    {
        name: "Jakery2012 BIO",
        filename: "Jakery2012 BIO.png",
    },
    {
        name: "Mathlab BIO",
        filename: "MathLab_Jordan.png",
    },
    {
        name: "Paulo Brum BIO",
        filename: "Paulo_Brum.png",
    },
    {
        name: "Jakery2012 Logo",
        filename: "Jakery2012 Logo.png",
    },
    {
        name: "JazPlaysBridge2b BIO",
        filename: "JazPlaysBridge2b BIO.png",
    },
    {
        name: "John_Stell BIO",
        filename: "John_Stell BIO.png",
    },
    {
        name: "JynxieLiving_2 BIO",
        filename: "JynxieLiving_2 BIO.png",
    },
    {
        name: "JynxieLiving_4 BIO",
        filename: "JynxieLiving_4 BIO.png",
    },
    {
        name: "Kuhchung2b BIO",
        filename: "Kuhchung2b BIO.png",
    },
    {
        name: "Peter Hollands BIO",
        filename: "peterhollands2 BIO.png",
    },
    {
        name: "Proquar BIO",
        filename: "Proquar_ BIO.png",
    },
    {
        name: "RasernKoopa BIO",
        filename: "RasernKoopa BIO.png",
    },
    {
        name: "Social Preview Banner",
        filename: "social-preview.jpeg",
    }
    // Add your new files here...
];

// Helper to get full path
export const getImagePath = (filename) => `/assets/images/${filename}`;